<template>
<div>
<el-row>
  <el-col :span="4"><div class="grid-content bg-purple" style="text-align: center;line-height: 50px;color: #ffffff">诚信服务后台管理</div></el-col>
  <el-col :span="20"><div class="grid-content bg-purple-light" style="text-align: center">
    <span style="font-weight: bold;font-size: 28px;line-height: 50px;color: #ffffff;">欢迎使用诚信后台管理系统</span>
    <a  style="float: right;margin-right: 50px;color: #ffffff;margin-top: 10px" @click="submitForm()"> <el-button size="small">退出</el-button></a>
  </div></el-col>
</el-row>
<el-container>
  <el-container>
    <el-aside width="190px">
      <el-col >
    <el-menu default-active="2" class="el-menu-vertical-demo" >
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location"></i>

          <span>信用公示</span>

        </template>
        <el-menu-item-group>
          <router-link to='/authenticationlist' tag="li" class="sidebar-nav-link">
          <el-menu-item index="1-1">信用评级</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>评价申请</span>
        </template>
        <el-menu-item-group>
          <router-link to='/creditlist' tag="li" class="sidebar-nav-link">
          <el-menu-item index="2-1">事项列表</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>信息发布</span>
        </template>
        <el-menu-item-group>
          <router-link to='/admininformation' tag="li" class="sidebar-nav-link">
          <el-menu-item index="3-1">发布信息</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>统计分析</span>
        </template>
        <el-menu-item-group>
          <router-link to='/admincreditlistbtn' tag="li" class="sidebar-nav-link">
          <el-menu-item index="4-1">公示业务数据</el-menu-item>
          </router-link>
        </el-menu-item-group>
        <el-menu-item-group>
          <router-link to='/adminevaluatelist' tag="li" class="sidebar-nav-link">
          <el-menu-item index="4-2">评价申请统计</el-menu-item>
          </router-link>
        </el-menu-item-group>
        <el-menu-item-group>
          <router-link to='/adminentlist' tag="li" class="sidebar-nav-link">
          <el-menu-item index="4-3">企业数据统计</el-menu-item>
          </router-link>
        </el-menu-item-group>
        <el-menu-item-group>
          <router-link to='/adminjglist' tag="li" class="sidebar-nav-link">
          <el-menu-item index="4-4">机构数据统计</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="5">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>用户管理</span>
        </template>
        <el-menu-item-group>
          <router-link to='/adminuserlist' tag="li" class="sidebar-nav-link">
          <el-menu-item index="5-1">企业信息</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="6">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>管理人信息修改</span>
        </template>
        <el-menu-item-group>
          <router-link to='/adminmanage' tag="li" class="sidebar-nav-link">
          <el-menu-item index="6-1">管理员列表</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>
         <el-submenu index="7">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span>系统管理</span>
        </template>
        <el-menu-item-group>
          <router-link to='/adminJournallist' tag="li" class="sidebar-nav-link">
          <el-menu-item index="7-1">系统日志</el-menu-item>
          </router-link>
        </el-menu-item-group>
      </el-submenu>

    </el-menu>
  </el-col>

    </el-aside>
    <el-main> <router-view></router-view></el-main>
  </el-container>
</el-container>

</div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {

  name: 'adminleftlist',
  data () {
    return {
      isState: '',
      pagenow: 1,
      sort: ''
    }
  },
  beforeCreate () {
    var that = this
    dataGetUrl(rootPathssb.rootPath + '/admini/list').then(function (response) {
      that.checkSignin(response.data.result)
    })
  },
  created () {
    var that = this
    dataGetUrl(rootPathssb.rootPath + '/admini/list').then(function (response) {
      that.checkSignin(response.data.result)
      that.adminManage = response.data.info
    }).catch(function (error) {
      console.log(error)
      console.log('aaa')
    })
  }, // 页面加载时
  methods: {
    submitForm (event) {
      localStorage.setItem('State-Check', '1')
      dataGetUrl(rootPathssb.rootPath + '/admini/signout').then(function (response) {
        console.log(response.data.msg)
        if (rootPathssb.sso) {
          if (response.data.result === 1) {
            localStorage.removeItem('Admin-Auth')
            window.location.href = response.data.msg
          }
          // window.location.href = '/signin'
        } else {
          if (response.data.result === 1) {
            alert('退出')
            localStorage.setItem('Admin-Auth', null)
            window.location.href = '/signin'
            console.log('cg')
          };
        }
      }).catch(function (error) {
        console.log(error); console.log(2222222222)
      })
    },
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    }
  }
}
</script>

<style scoped>
    a {text-decoration:none;
    color: #333333;
  }
  .bg-purple {
    background: #337ab7;
  }
  .bg-purple-light {
    background: #337ab7;
  }
  .grid-content {
  }

  .el-aside {
    background-color: #ffffff;
    color: #333;
    text-align: left;
    min-height: 1000px;
  }

  .el-main {
    background-color: #E9EEF3;
    color: #333;
    min-height: 1000px;
  }

</style>



// WEBPACK FOOTER //
// src/components/admin/adminleftlist.vue